import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { slugify } from "../../utils";

const ServiceProp = ({ colSize, serviceStyle, serviceData }) => {

  const [isMobileOrTablet, setIsMobileOrTablet] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobileOrTablet(window.innerWidth < 1023); // tablet and below
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      {serviceData.map((data, index) => (
        <div
          className={colSize}
          key={index}
          style={{ paddingTop: "15px", paddingBottom: "15px" }}
        >
          <div className={`services-grid ${serviceStyle}`} 
          style={{ marginBottom: isMobileOrTablet ? "0" : "30px" }}
          >
            <div className="thumbnail">
              <img src={process.env.PUBLIC_URL + data.image} alt="icon" />
            </div>
            <div className="content">
              <h5 className="title">
                <Link
                  to={
                    data.mainCategory === "IFM Services"
                      ? `/service/${slugify(data.title)}`
                      : `/service/${slugify(data.mainCategory)}/${slugify(
                          data.title
                        )}`
                  }
                >
                  {data.title}
                </Link>
              </h5>
              <p style={{margin: isMobileOrTablet ? "0 0 15px 0" : "0 0 40px 0"}}>{data.description}</p>
              <Link
                to={
                    data.mainCategory === "IFM Services"
                      ? `/service/${slugify(data.title)}`
                      : `/service/${slugify(data.mainCategory)}/${slugify(
                          data.title
                        )}`
                  }
                className="more-btn"
                style={{paddingBottom: isMobileOrTablet ? "0" : "40px"}}
              >
                Find out more {isMobileOrTablet ? "→" : ""}
              </Link>
            </div>
          </div>
        </div>
      ))}
    </>
  );
};

export default ServiceProp;
